/**
 * Лаг витрины подписей карты (AK-772).
 *
 * Подпись поля на карте приезжает НЕ из таблицы `fields`, а из
 * материализованной витрины `field_visual_attrs`
 * (`label_number = COALESCE(name, number)`). Витрину обновляет слушатель
 * NOTIFY внутри backend-процесса (AK-586, `services/map_mv_scheduler.py`) с
 * дебаунсом `map_mv_refresh_debounce_s = 2.0` — то есть между «ручка вернула
 * 200» и «в тайле новое имя» проходит пара секунд плюс сам REFRESH.
 *
 * Отсюда правило для действий, меняющих ИМЯ поля: перезапрашивать тайлы надо
 * дважды — сразу (вдруг витрина уже свежая) и ещё раз за этим окном. Одной
 * немедленной инвалидации мало: она гарантированно утащит тайл со старой
 * подписью, и человек прочитает это как «переименование не сработало».
 *
 * Существование поля (архивация) в этом окне НЕ нуждается: тайл фильтрует
 * `fields.archived_at IS NULL` по живой таблице.
 *
 * Значение — дебаунс (2 с) с запасом на сам REFRESH. Держать вместе с
 * `map_mv_refresh_debounce_s` в `backend/src/ikolhoz/config.py`: вырастет
 * дебаунс — вырастет и это число.
 */
export const MAP_MV_LAG_MS = 3500;
